/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { StockItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Download } from '../Download/Download';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface StockProps extends StockItemProps {
    checkboxClassname?: string;
}

export const Stock: FC<StockProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download onClick={props.onDownload} ext={props.ext} size={props.size} id={props.id} storage={props.storage} />
            </TableColumn>
        </>
    );
};
